import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EntityService } from '../../shared/services/entity.service';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BookmarkDocumentService } from '../../shared/services/bookmark-document.service';
import { BookmarkFolderService } from '../../shared/services/bookmark-folder.service';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Folder } from '../../models/folder';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEditFolderComponent } from '../modal-edit-folder/modal-edit-folder.component';
import { Impacter } from '../../models/impacter/impacter';
import { ImpacterPosition } from '../../models/impacter/impacter-position';
import { AutoUnsubscribe } from "../../common-explain/decorators/auto-unsubscribe";

@AutoUnsubscribe
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showContent!: boolean;
  @Input() inFolderView!: boolean;
  @Input() territoryUid!: string;
  public document: object | null = null;
  public impacter: Impacter | null = null;
  public label!: string | null;
  public preLabel!: string | null;
  public toggled = true;
  public guestDisplay = false;
  public folderView = false;
  public impacterView = false;
  public showContentFolder = false;
  public folder: Folder | null = null;
  public entityId: string | null = null;
  contentRef: Element | null = document.querySelector('.root-content');
  subscription: Subscription = new Subscription();

  constructor(private entityService: EntityService,
              private route: ActivatedRoute,
              private router: Router,
              private bookmarkDocumentService: BookmarkDocumentService,
              private bookmarkFolderService: BookmarkFolderService,
              private modalService: NgbModal
  ) {
    this.subscription.add(
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {
            let routeToSubscribe = this.route.snapshot;
            while (routeToSubscribe.firstChild) {
              routeToSubscribe = routeToSubscribe.firstChild;
            }
            return routeToSubscribe;
          })
        )
        .subscribe((lastChildRoute: ActivatedRouteSnapshot) => {
          this.document = null;
          this.label = null;
          this.preLabel = null;
          this.folderView = !!lastChildRoute.data['folderView'];
          this.showContentFolder = !!lastChildRoute.data['showContentFolder'];
          this.impacterView = !!lastChildRoute.data['impacterView'];
          if (this.impacterView && this.impacter) this.entityService.sendImpacter(this.impacter);
          if (this.folderView) {
            this.bookmarkFolderService.getFolderSubject().subscribe((folder: Folder | null) => {
              this.folder = folder;
            });
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.route.data.subscribe((data: any) => {
      if (data.guestDisplay) {
        this.guestDisplay = data.guestDisplay;
      }
    });

    this.entityService.getDocument().subscribe((document:any) => {
      this.document = document;
      if (document) {
        this.label = document['title'];
      } else if (this.impacter && this.impacter.name) {
        this.label = this.impacter.name;
      } else {
        this.label = null;
      }

      if (this.impacter && document) {
        this.preLabel = this.impacter.name;
      } else {
        this.preLabel = null;
      }
    });

    this.entityService.getImpacter().subscribe((impacter) => {
      this.impacter = impacter;
      if (impacter) {
        this.label = impacter.name;
        this.preLabel = null;
        this.contentRef?.classList.add('min-height');
      } else {
        this.label = null;
        this.preLabel = null;
        this.contentRef?.classList.remove('min-height');
      }
    });

    this.entityService.getEntityId().subscribe((id) => {this.entityId = id;})
  }

  toggle() {
    this.toggled = !this.toggled;
    if (!this.toggled) {
      this.contentRef?.classList.add('min-height-expand');
    } else {
      this.contentRef?.classList.remove('min-height-expand');
    }
  }

  getPositions(positions: Array<ImpacterPosition>, isCurrent: boolean): Array<ImpacterPosition> {
    return positions.filter(position => position.isOld !== isCurrent);
  }

  openEditFolderModal() {
    const modalRef = this.modalService.open(ModalEditFolderComponent,
      {ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'modal-width-419'});
    modalRef.componentInstance.translationFileSection = 'folder';
    modalRef.componentInstance.folder = this.folder;
    modalRef.result.then((newName: string) => {
      if (!this.folder) return;
      this.folder.name = newName;
      this.bookmarkFolderService.folder = this.folder;
    }, _ => {
      // error handling when dismissing the modal, nothing to do but keep it to prevent console error.
    });
  }
}
